import React from 'react';
import { MapPin, Phone, Mail, Clock, MessageCircle } from 'lucide-react';

const Contact = () => {
  const contactInfo = [
    {
      icon: MapPin,
      title: 'Our Location',
      details: ['Nagra Building Complex', 'Near Namdhari Tailor', 'Ambala Chandigarh Highway, Zirakpur']
    },
    {
      icon: Phone,
      title: 'Call Us',
      details: ['92573-00815'],
      link: 'tel:9257300815'
    },
    {
      icon: Mail,
      title: 'Email Us',
      details: ['hsrbusinesspromoters@gmail.com'],
      link: 'mailto:hsrbusinesspromoters@gmail.com'
    },
    {
      icon: Clock,
      title: 'Business Hours',
      details: ['Monday - Saturday: 9:00 AM - 7:00 PM', 'Sunday: By Appointment']
    }
  ];

  const handleWhatsAppClick = () => {
    window.open('https://wa.me/919257300815?text=Hi, I would like to know more about your digital marketing services.', '_blank');
  };

  return (
    <section id="contact" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-sm font-semibold text-gray-600 uppercase tracking-wide">Get In Touch</span>
          <h2 className="mt-2 text-4xl lg:text-5xl font-bold text-gray-900" style={{ fontFamily: 'var(--font-serif)' }}>
            Let's Grow Your Business Together
          </h2>
          <p className="mt-4 text-lg text-gray-600 max-w-3xl mx-auto">
            Ready to take your digital marketing to the next level? Contact us today for a free consultation.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12">
          {/* Contact Information */}
          <div className="space-y-8">
            {contactInfo.map((info, index) => {
              const IconComponent = info.icon;
              return (
                <div key={index} className="flex items-start space-x-4">
                  <div className="flex-shrink-0">
                    <div className="w-14 h-14 bg-black rounded-lg flex items-center justify-center">
                      <IconComponent className="w-7 h-7 text-white" />
                    </div>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-900 mb-2">{info.title}</h3>
                    {info.link ? (
                      <a 
                        href={info.link} 
                        className="text-gray-600 hover:text-gray-900 transition-colors"
                      >
                        {info.details.map((detail, idx) => (
                          <p key={idx} className="text-lg">{detail}</p>
                        ))}
                      </a>
                    ) : (
                      info.details.map((detail, idx) => (
                        <p key={idx} className="text-gray-600">{detail}</p>
                      ))
                    )}
                  </div>
                </div>
              );
            })}

            {/* WhatsApp CTA */}
            <div className="bg-green-50 border-2 border-green-200 rounded-xl p-6">
              <div className="flex items-center space-x-4">
                <div className="flex-shrink-0">
                  <MessageCircle className="w-12 h-12 text-green-600" />
                </div>
                <div className="flex-1">
                  <h3 className="text-lg font-bold text-gray-900 mb-1">Quick Response on WhatsApp</h3>
                  <p className="text-gray-600 text-sm mb-3">Get instant answers to your queries</p>
                  <button
                    onClick={handleWhatsAppClick}
                    className="bg-green-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-green-700 transition-colors duration-200 flex items-center gap-2"
                  >
                    <MessageCircle className="w-5 h-5" />
                    Chat on WhatsApp
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Map */}
          <div className="bg-white rounded-xl shadow-lg overflow-hidden h-[500px]">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13730.764899999999!2d76.8178!3d30.6417!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390f95e0a0a0a0a1%3A0x0!2sZirakpur!5e0!3m2!1sen!2sin!4v1234567890123!5m2!1sen!2sin"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="HSR Business Promoters Location"
            ></iframe>
          </div>
        </div>

        {/* CTA Banner */}
        <div className="mt-16 bg-black rounded-2xl p-12 text-center">
          <h3 className="text-3xl font-bold text-white mb-4" style={{ fontFamily: 'var(--font-serif)' }}>
            Ready to Transform Your Digital Presence?
          </h3>
          <p className="text-gray-300 text-lg mb-8 max-w-2xl mx-auto">
            Join hundreds of successful professionals who trust HSR Business Promoters for their digital marketing needs.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <a href="tel:9257300815">
              <button className="bg-white text-black px-8 py-4 rounded-lg font-semibold hover:bg-gray-100 transition-colors duration-200 flex items-center gap-2">
                <Phone className="w-5 h-5" />
                Call Now: 92573-00815
              </button>
            </a>
            <a href="mailto:hsrbusinesspromoters@gmail.com">
              <button className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-lg font-semibold hover:bg-white hover:text-black transition-colors duration-200 flex items-center gap-2">
                <Mail className="w-5 h-5" />
                Email Us
              </button>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
